import type { VisualizationProps } from './types';

/**
 * ChildrenSVG — детская: стенка-горка с 3 секциями разной высоты.
 * Зоны: facade, corpus, handles. Без countertop/hooks. Конвенции — `./types.ts`.
 */
export function ChildrenSVG({ facadeColor, corpusColor, handlesColor }: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      <rect
        data-testid="zone-corpus"
        x="30"
        y="20"
        width="80"
        height="165"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="115"
        y="80"
        width="90"
        height="105"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="210"
        y="20"
        width="80"
        height="165"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="36"
        y="26"
        width="68"
        height="153"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="121"
        y="86"
        width="78"
        height="93"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        x="216"
        y="26"
        width="68"
        height="153"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="62"
        y="100"
        width="2"
        height="12"
        fill={handlesColor}
        rx="1"
      />
      <rect x="155" y="125" width="2" height="12" fill={handlesColor} rx="1" />
      <rect x="245" y="100" width="2" height="12" fill={handlesColor} rx="1" />
      <text
        x="70"
        y="105"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="160"
        y="60"
        textAnchor="middle"
        fontSize="9"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
    </svg>
  );
}
